import React from 'react';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';

// Feed purchases created from the Daily Entries purchases section. The server owns them through the daily
// entries, so they are read-only here and changed only by editing the daily entries.
export const AUTO_PURCHASE_MESSAGE = 'This purchase was auto-generated from Daily Entries. To change it, edit the feed received in Daily Entries.';

export const isAutoGeneratedPurchase = (purchase) => purchase && purchase.isAutoGeneratedPurchase === 1;

export const AutoGeneratedChip = ({ purchase }) => {
    if (!isAutoGeneratedPurchase(purchase)) {
        return null;
    }
    return (
        <Tooltip title={AUTO_PURCHASE_MESSAGE}>
            <Chip label='Auto-generated' size='small' variant='outlined' color='secondary' style={{ marginLeft: 6 }} />
        </Tooltip>
    );
};
